import { NamedDefinitionPage } from './NamedDefinitionPage';

export function ProductGroupsPage() {
  return (
    <NamedDefinitionPage
      apiBase="/api/productgroups"
      listRoute="/product-groups"
      title="Ürün Grubu"
      subtitle="Ürün grubu kayıtlarını filtreleyin, sıralayın ve yönetin."
      codeLabel="Grup Kodu"
      descriptionLabel="Açıklama"
      newLabel="Yeni Ürün Grubu"
      exportName="urun-gruplari"
      entityLabel="ürün grubu"
    />
  );
}
